<template>
  <div :id="uuid" :style="{width:width+'px',height:height+'px'}"/>
</template>

<script setup>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty } from "@/utils/refresh-cpt-data";
import {onMounted, watch, computed} from "vue";
import * as echarts from 'echarts'

const props = defineProps({
  width:Number,
  height:Number,
  option:Object,
  show:Boolean,
  components:Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
watch(() => props.option.attribute, (obj) => {
  if(obj.dataZoom && obj.dataZoom.show) {
     obj.grid.y2 = obj.grid.y2 == 30 ? 50 : obj.grid.y2;
   } else {
     obj.grid.y2 = obj.grid.y2 == 50 && obj.grid.y2 != 30 ? 30 : obj.grid.y2;
   }
  processData(props.option.cptDataForm,newData,jsFunFlag)
  loadChart(obj);
},{deep:true})
watch(() => [props.width,props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(()=>{
  chart = echarts.init(document.getElementById(uuid))
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm,paras){
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm,paras),
  props.components)
}
function loadData(cptDataForm,paras){
  getDataJson(cptDataForm,paras,(res)=> {
        // cptData = res;
          newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
          jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
          processData(cptDataForm,newData,jsFunFlag)
        loadChart(props.option.attribute);

      })
}
function processData(cptDataForm,res,jsFunFlag){
          // 第一层判断 如果选择数据集
          if(cptDataForm.dataSource == '4') {
            // 第二层判断 ，如果没有配转换脚本
            if(jsFunFlag) { // 没有全部配置映射字段
                if(hasNonEmptyValues(props.option.attribute.cptTableData)) {
                    const dataKey = props.option.attribute.cptTableData;
                     let newarr = [];
                      // 遍历原始数组并重组数据
                      res.forEach(item => {
                        let group = item[dataKey[0].value];
                        let dimension = item[dataKey[1].value];
                        let start = item[dataKey[2].value];
                        let end = item[dataKey[3].value];

                        // 查找或创建对应的分组对象
                        let groupItem = newarr.find(groupObj => groupObj.name === group);
                        if (!groupItem) {
                          groupItem = { name: group, data: [] };
                          newarr.push(groupItem);
                        }
                        // 在对应分组的数据数组中添加维度和指标
                        groupItem.data.push({ name: dimension, start, end });
                      });
                        console.log(newarr,'新数组')
                        cptData = newarr; 
              }
             } else { // 如果配置了转换脚本
                cptData = res;
             }
          } else { // 不是数据集类型，是静态数据
               cptData = res;
          } 
    }
function loadChart(attr){
  if(chart){
    chart.clear()
  }
  const attrClone = JSON.parse(JSON.stringify(attr))
  attrClone.xAxis.type = 'category';
  attrClone.yAxis.type='value';
  attrClone.xAxis.data = [];
  attrClone.yAxis.data = [];
  let axis = 'xAxis';
  if(attr.direction === 'y'){
    axis = 'yAxis'
    attrClone.xAxis.type = 'value';
    attrClone.yAxis.type='category';
  }
 cptData[0].data.forEach(item => {
    attrClone[axis].data.push(item.name)
  })
  let series = [];
  for (let i = 0; i < cptData.length; i++) {
    const item = cptData[i];
    const startData = [];
    const endData = [];
    item.data.forEach(data => {
      const index = attrClone[axis].data.indexOf(data.name);
      startData[index] = data.start
      endData[index] = data.end
    })
    series.push({
      stack: item.group,
      type: 'bar',
      barWidth: attr.series.barWidth,
      itemStyle: {
        color: attr.color[cptData.length+i] ? attr.color[cptData.length+i] : 'transparent'
      },
      data: startData
    })
    series.push({
      name: item.group,
      stack: item.group,
      type: 'bar',
      backgroundStyle: {
        color: 'rgba(180, 180, 180, 0.2)'
      },
      label:attr.series.label,
      barWidth: attr.series.barWidth,
      data: endData
    })
  }
  
  chartOption = Object.assign(attrClone,{series:series});
 
  chart.setOption(chartOption);
  chart.on('click', (params) => {
    emit("clickHandler",props.option.interaction,'default',params.name)
  })
}

defineExpose({refreshCptData})
</script>

<style scoped>

</style>
